export default __webpack_public_path__ + "static/cardstackedmaxdo-c01d18b203fc2af50d6cf247bf8df41d.png";